import { z } from 'zod'

export const customerSchema = z.object({
  first_name: z.string().min(1, 'First name is required'),
  last_name: z.string().optional(),
  phone: z.string().min(1, 'Phone is required'),
  email: z.string().email('Invalid email address').optional().or(z.literal('')),
  id_card_number: z.string().optional(),
  status: z.enum(['active', 'alumni', 'prospect', 'external']),
})

export type CustomerFormData = z.infer<typeof customerSchema>
